import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ChangeRequestApiService from '../../../../api/ChangeRequestApiService';
import ChangeRequestLayout from '../../../../components/postSecondary/ChangeRequestLayout';
import NewProgramChangeRequestStep12Form from '../../../../components/forms/postSecondary/NewProgramChangeRequestStep12Form';
import Routes from '../../../../config/Routes';
import ChangeRequestType from '../../../../consts/ChangeRequestType';
import * as GetBaseChangeRequestDetailsHandler from '../../../../handlerModels/GetBaseChangeRequestDetailsHandler';
import ChangeRequestDTO from '../../../../models/ChangeRequestDTO';
import InstitutionDTO from '../../../../models/InstitutionDTO';
import UserSecurity from '../../../../models/UserSecurity';
import BaseFormState from '../../../../redux/bases/BaseFormState';
import { StateStoreModel } from '../../../../redux/state/StateStoreModel';
import Guid from '../../../../utils/Guid';
import HistoryUtil from '../../../../utils/HistoryUtil';
import ParameterUtil from '../../../../utils/ParameterUtil';

interface NewProgramChangeRequestStep12PageState extends BaseFormState {
  changeRequestId: string;
  awardId: string;
  changeRequest: ChangeRequestDTO;
  isAwardNew: boolean;
}

interface NewProgramChangeRequestStep12PageProps {
  selectedInstitution: InstitutionDTO | null;
  currentUser: UserSecurity | null;
}

class NewProgramChangeRequestStep12Page extends React.Component<NewProgramChangeRequestStep12PageProps & RouteComponentProps<RouteObject>, NewProgramChangeRequestStep12PageState> {

  constructor(props: NewProgramChangeRequestStep12PageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      isAwardNew: false,
      changeRequestId: Guid.Empty(),
      awardId: Guid.Empty(),
      changeRequest: ChangeRequestDTO.create(),
    };
  }

  componentDidMount() {
    const id = ParameterUtil.getPathPart(this.props.match, 'id');
    const awardId = ParameterUtil.getPathPart(this.props.match, 'awardId');

    if (id == 'new') {
      this.setState({ isNew: true });
    }
    else if (id !== Guid.Empty() && this.state.changeRequestId != id) {
      this.setState({ changeRequestId: id });
      this.fetchData(id);
    }

    if (awardId == ' new') {
      this.setState({ isAwardNew: true })
    }
    else if (awardId !== Guid.Empty() && this.state.awardId != awardId) {
      this.setState({ awardId: awardId });
    }
  }

  private fetchData = (id: string) => {
    this.setState({ loading: true });

    const loaders = [];

    if (id !== Guid.Empty()) {
      loaders.push(this.loadChangeRequest(id));
    }

    Promise.all(loaders).then(() => {
      this.setState({ loading: false });
    });
  }

  private loadChangeRequest = (id: string) => {
    return ChangeRequestApiService.getBaseChangeRequestDetails(id)
      .then((results: GetBaseChangeRequestDetailsHandler.Result) => {
        if (results) {
          this.setState({
            changeRequest: results.changeRequest ?? ChangeRequestDTO.create(),
          });
        }
      }).catch(() => {
        this.setState({ error: true, message: 'Could not load change request.' });
      });
  }

  private goToNextStep = () => {
    if (this.state.changeRequest.newProgramChangeRequest?.isTransferMajorProgram) {
      HistoryUtil.push(Routes.generate(Routes.EXISTING_NEW_PROGRAM_CHANGE_REQUEST_ENTRY_14, { id: this.state.changeRequestId, awardId: this.state.awardId }));
    }
    else {
      HistoryUtil.push(Routes.generate(Routes.EXISTING_NEW_PROGRAM_CHANGE_REQUEST_ENTRY_13, { id: this.state.changeRequestId, awardId: this.state.awardId }));
    }
  }

  private goToPreviousStep = () => {
    if (this.state.changeRequest.newProgramChangeRequest?.isTransferMajorProgram) {
      let awardId = Guid.Empty();

      if (awardId == Guid.Empty()) {
        const awards = this.state.changeRequest?.newProgramChangeRequest?.newProgramProgramAwards;
        if (awards && awards.length > 0) {
          awardId = awards[0].id ?? Guid.Empty()
        }
      }
      HistoryUtil.push(Routes.generate(Routes.EXISTING_NEW_PROGRAM_CHANGE_REQUEST_ENTRY_11, { id: this.state.changeRequestId, awardId: awardId ?? Guid.Empty }));
    }
    else {
      HistoryUtil.push(Routes.generate(Routes.EXISTING_NEW_PROGRAM_CHANGE_REQUEST_ENTRY_9, { id: this.state.changeRequestId }, {}))
    }
  }

  render() {
    return (
      <Content >
        <ChangeRequestLayout
          changeRequest={this.state.changeRequest ?? ChangeRequestDTO.create()}
          stepNumber={this.state.changeRequest.changeRequestTypeId === ChangeRequestType.NEWTRANSFERMAJORPROGRAM ? 7 : 11}
          currentUser={this.props.currentUser ?? {} as UserSecurity}>
          <Card title="ICCPHSE" >
            <NewProgramChangeRequestStep12Form
              changeRequestId={this.state.changeRequest.id}
              loading={this.state.loading}
              onSubmit={this.goToNextStep}
              onPrevious={this.goToPreviousStep} />
          </Card >
        </ChangeRequestLayout>
      </Content >
    );
  }
}

function mapStateToProps(state: StateStoreModel) {
  return {
    selectedInstitution: state.Institution.Selected,
    currentUser: state.UserSession.Value
  };
}

export default withRouter(connect(mapStateToProps)(NewProgramChangeRequestStep12Page));